import { OrderStep } from 'src/app/shared/enums/order-step.enum';
import { Sample } from 'src/app/shared/models/sample.model';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { SampleView } from 'src/app/shared/enums/sample-view.enum';
import { GuidedOrderState } from 'src/app/shared/models/guided-order-state.model';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SwitchStepService {

  private readonly noJumpStep = -1;

  @Output() checkData: EventEmitter<any> = new EventEmitter();
  @Output() dataValid: EventEmitter<boolean> = new EventEmitter();
  @Output() recipientErrorMessageRemove: EventEmitter<boolean> = new EventEmitter();
  @Output() moveNextStep: EventEmitter<boolean> = new EventEmitter();
  @Output() initiateSwitch: EventEmitter<boolean> = new EventEmitter();
  @Output() showOrderFooter: EventEmitter<boolean> = new EventEmitter();
  // Using ReplaySubject(1) to buffer the last emitted value, ensuring late subscribers receive it
  // This fixes the race condition where navigation fails randomly due to timing issues
  jump: ReplaySubject<number> = new ReplaySubject<number>(1);
  @Output() retain: EventEmitter<boolean> = new EventEmitter();
  @Output() confirmOrder = new EventEmitter();
  @Output() specifications: EventEmitter<Sample> = new EventEmitter();
  @Output() specificationsReply: EventEmitter<boolean> = new EventEmitter();
  @Output() loadSampleInitPage: EventEmitter<boolean> = new EventEmitter();
  @Output() showChangeInSnap: EventEmitter<boolean> = new EventEmitter();
  @Output() currentStepChange: EventEmitter<OrderStep> = new EventEmitter();

  private repliedCount = 0;
  private repliedStatus = true;
  sampleSelectionHelpViewed = false;

  private guidedOrderState: GuidedOrderState = new GuidedOrderState();

  constructor() {
    // Initialize with a sentinel so new subscribers do not navigate on stale replay.
    this.jump.next(this.noJumpStep);
  }

  switch() {
    this.checkData.emit();
  }

  jumpTo(step: number) {
    this.jump.next(step);
  }

  clearJump() {
    this.jump.next(this.noJumpStep);
  }

  reply(initiate: boolean) {
    const totalSubscribers = this.checkData.observers.length;

    if (totalSubscribers <= this.repliedCount) {
      this.repliedCount = 0;
      this.repliedStatus = true;
    }

    this.repliedCount++;
    if (!initiate) {
      this.repliedStatus = false;
    }

    if (totalSubscribers <= this.repliedCount && this.repliedStatus) {
      this.initiateSwitch.emit(initiate);
      this.repliedCount = 0;
    }
  }

  showHideFooter(show: boolean) {
    this.showOrderFooter.emit(show);
  }

  update(valid: boolean) {
    this.dataValid.emit(valid);
  }

  clearRecipientErrorMessage(flag: boolean)
  {
    this.recipientErrorMessageRemove.emit(flag);
  }

  nextStep(value: boolean) {
    this.moveNextStep.emit(value);
  }

  confirm() {
    this.confirmOrder.emit();
  }

  jumped() {
    this.retain.emit(true);
  }

  showSpecifications(sample: Sample) {
    this.specifications.emit(sample);
  }

  showSpecificationsReply(status: boolean) {
    this.specificationsReply.emit(status);
  }

  reloadSampleInitData() {
    this.loadSampleInitPage.emit(true);
  }

  showChangeButtonInSnap(value: boolean) {
    this.showChangeInSnap.emit(value);
  }

  setCurrentStep(value: OrderStep) {
    this.currentStepChange.emit(value);
  }

  setSampleView(sampleView: SampleView) {
    this.guidedOrderState.sampleView = sampleView;
  }

  getGuidedOrderState() {
    return this.guidedOrderState;
  }

  setSSHStatusViewed() {
    this.sampleSelectionHelpViewed = true;
  }

}
